import React, { forwardRef, Ref, SVGProps } from 'react'

const _IconTopVillasRectangle = (props: SVGProps<SVGSVGElement>, ref?: Ref<SVGSVGElement>) => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" {...props} ref={ref}>
    <rect x="0.399902" width="24" height="24" rx="6" fill="black" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.4999 6C7.3401 6 6.3999 6.9402 6.3999 8.1V15.9C6.3999 17.0598 7.3401 18 8.4999 18H16.2999C17.4597 18 18.3999 17.0598 18.3999 15.9V8.1C18.3999 6.9402 17.4597 6 16.2999 6H8.4999ZM9.3999 10.425H8.4999L12.3999 7.77594V7.725L12.4374 7.75047L12.4749 7.725V7.77594L16.3749 10.425H15.3999V15.3H9.3999V10.425Z"
      fill="white"
    />
  </svg>
)

export const IconTopVillasRectangle = forwardRef(_IconTopVillasRectangle)
